var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_V1_PATH } from "@/06-shared/api/request/config";
import { request } from "@/06-shared/api/request";
const BOOKS_API_PATH = `${API_V1_PATH}/books`;
export const getBooks = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (filters = {}) {
    const searchParams = new URLSearchParams();
    if (filters.genre) {
        searchParams.set("genre", filters.genre);
    }
    if (filters.available !== undefined) {
        searchParams.set("available", String(filters.available));
    }
    const query = searchParams.size > 0 ? `?${searchParams.toString()}` : "";
    return request(`${BOOKS_API_PATH}${query}`);
});
export const getBook = (bookId) => __awaiter(void 0, void 0, void 0, function* () {
    return request(`${BOOKS_API_PATH}/${bookId}`);
});
export const createBook = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    return request(BOOKS_API_PATH, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
});
export const deleteBook = (bookId) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${BOOKS_API_PATH}/${bookId}`, {
        method: "DELETE"
    });
});
export const releaseBook = (bookId) => __awaiter(void 0, void 0, void 0, function* () {
    yield request(`${BOOKS_API_PATH}/${bookId}/release`, {
        method: "POST"
    });
});
